import React, { useEffect, useState } from 'react';

import { Divider, Form, Modal } from 'antd';

import MyButton from './Button';

import Typography from './Typography';
import { COLORS } from '../constants/Colors';
import OrderForm from './OrderForm';
import SelectCustomerModal from './SelectCustomerModal';
import SelectAddrModal from './SelectAddrModal';
import useIsDesktop from '../utils/hooks/useIsDesktop';
import { instance } from './AxiosClient';
import GetProfile from './VariableStore';
import _ from 'lodash';
import moment from 'moment';
import { errorNotification, successNotification } from './Notification';
import { FormattedMessage, useIntl } from 'react-intl';
import { useDispatch } from 'react-redux';
import { triggerAction } from '../utils/redux/actions/globalReducer'
// import { useState } from "react";

const OrderModal = (props) => {
  const {
    isOpen,
    onCancle,
    isEdit,
    onSave,
    info,
    saveEditOrder,
    fromTracking,
  } = props;
  const isDesktop = useIsDesktop();
  const intl = useIntl();
  const dispatch = useDispatch()
  const [isOpenSelectCustomer, setIsOpenSelectCustomer] = useState(false);
  const [isOpenSelectAddr, setIsOpenSelectAddr] = useState(false);
  const [customerData, setCustomerData] = useState([]);
  const [customerDetail, setCustomerDetail] = useState([]);
  const [addressData, setAddressData] = useState([]);
  const [event, setEvent] = useState(false);
  const [eventAddress, setEventAddress] = useState(false);
  const [formCustomer] = Form.useForm();
  const [isDisable, setIsDisable] = useState(true);
  const [contactData, setContactData] = useState([]);
  const [selectaddressData, setSelectAddressData] = useState([]);
  const [isOrder, setIsOrder] = useState(false);
  const [tempDataCus, setTempDataCus] = useState([]);
  const [tempDataAdd, setTempDataAdd] = useState([]);
  const [saveAddes, setSaveAddes] = useState([]);
  const [sizeProduce, setSizeProduce] = useState([]);
  const [count, setCount] = useState(0);

  const customerId = GetProfile('customerId');
  const comCode = GetProfile('customerCode');

  const targetObject = { id: 2, name: 'Bob' };

  // //console.log(
  //   'CDF',
  //   selectaddressData
  //   _.get(info, 'contact.customerContactId'),
  //   _.get(_.findLast(tempDataCus), 'customerContactId'),
  //   _.findIndex(customerData, { customerContactId: _.get(info, 'contact.customerContactId') })
  //   _.includes(_.get(info, 'contact.customerContactId'), )
  //   _.get(_.findLast(tempDataAdd), 'customerAddressBookId'),
  // );

  useEffect(() => {
    if (comCode && customerId && isOpen === true) {
      getCustomerData();

      getSize();
      // if (isEdit) {
      //   getEditAddress(_.get(info, 'contact.customerContactId'), _.get(info, 'destination.customer_address_book_id'));
      //   formCustomer.setFieldsValue({
      //     name: _.get(info, 'contact.customerContactId'),
      //     phone: _.get(info, 'contact.customerContactPhone'),
      //     address: _.get(info, 'destination.customer_address_book_id'),
      //     parcel: _.get(info, 'parcel') ? _.get(info, 'parcel') : '',
      //     ref: _.get(info, 'referenceNo') ? _.get(info, 'referenceNo') : '',
      //     price: _.get(info, 'customerShippingPriceNumber') ? _.get(info, 'customerShippingPriceNumber') : '',
      //     remark: _.get(info, 'referenceNo') ? _.get(info, 'referenceNo') : '',
      //   });
      //   setIsDisable(false);
      // }
    }
  }, [isOpen, event]);

  useEffect(() => {
    if (contactData && customerId && isOpen === true) {
      getDataAddress(_.get(contactData, 'customerContactId'));
    }

    if (isOpenSelectAddr === true) {
      setIsOrder(true);
    }
  }, [eventAddress && customerId]);

  useEffect(() => {
    if (isOpen === true) {
      if (isEdit) {
        getEditCustomer();
        getEditAddress(_.get(info, 'contact.customerContactId'), _.get(info, 'destination.customer_address_book_id'));

        formCustomer.setFieldsValue({
          name: _.get(info, 'contact.customerContactId'),
          phone: _.get(info, 'contact.customerContactPhone'),
          address: _.get(info, 'destination.customer_address_book_id'),
          parcel: _.get(info, 'parcel') ? _.get(info, 'parcel') : '',
          ref: _.get(info, 'referenceNo') ? _.get(info, 'referenceNo') : '',
          price: _.get(info, 'customerShippingPriceNumber') ? _.get(info, 'customerShippingPriceNumber') : '',
          remark: _.get(info, 'remark') ? _.get(info, 'remark') : '',
        });
        setIsDisable(false);
      }
    }
  }, [isOpen]);

  const getEditCustomer = async () => {
    handleSelectName(_.get(info, 'contact.customerContactId'), await getCustomerData());
    // //console.log('getCustomerData',await getCustomerData());
  };

  const getEditAddress = async (conId, AddressId) => {
    const id = await _.get(info, 'contact.customerContactId');

    handleSelectAddress(_.get(info, 'destination.customer_address_book_id'), await getDataAddress(conId));
  };

  const getCustomerData = async () => {
    try {
      const response = await instance.get(`/v3/business-partner/manager/company/${comCode}/customer-informations/${customerId}`);
      setCustomerData(response.data.data.contacts);

      const detail = _.get(response, 'data.data');
      setCustomerDetail({
        businessType: _.get(detail, 'businessType.businessTypeName'),
        comtomerName: _.get(detail, 'customerName'),
        customerId: _.get(detail, 'customerId'),
        customerType: _.get(detail, 'customerType.customerTypeName'),
        phone: _.get(detail, 'phone'),
        position: null,
        profileImg: _.get(detail, 'profileImg'),
        address: _.get(detail, 'address'),
      });

      if (_.size(tempDataCus) > 0) {
        if (_.findIndex(customerData, { customerContactId: _.get(_.findLast(tempDataCus), 'customerContactId') }) === -1) {
          const newData = [...customerData, _.findLast(tempDataCus)];
          setCustomerData(newData);
        }
      }

      if (isEdit === true) {

        if (_.findIndex(customerData, { customerContactId: _.get(info, 'contact.customerContactId') }) === -1) {
          const newData = [
            {
              customerContactEmail: _.get(info, 'contact.customerContactEmail') ? _.get(info, 'contact.customerContactEmail') : undefined,
              customerContactId: _.get(info, 'contact.customerContactId'),
              customerContactName: _.get(info, 'contact.customerContactName'),
              customerContactPhone: _.get(info, 'contact.customerContactPhone'),
            },
          ];
          setCustomerData((prevArrays) => _.uniqBy([...prevArrays, ...newData], 'customerContactId'));
          return newData;
        } else {
          return response.data.data.contacts;
        }
      }

      const warehouseCode = process.env.REACT_APP_WAREHOUSE_CODE;
      const responseAdd = await instance.get(`/v1/warehouse/manager/company/${comCode}/web/warehouse-detail/loopmerchant/${warehouseCode}`);
      const detailAdd = _.get(responseAdd, 'data.data');
      setSaveAddes({
        address_name: _.get(detailAdd, 'warehouseName'),
        address: _.get(detailAdd, 'address'),
        lat: _.get(detailAdd, 'lat'),
        lng: _.get(detailAdd, 'lng'),
      });
    } catch (error) { }
  };

  const getDataAddress = async (contactId, AddressId) => {

    try {
      const response = await instance.get(
        `/v3/business-partner/manager/company/${process.env.REACT_APP_COM_CODE}/customer-address-books?customerId=${customerId}&contactId=${contactId}`
      );
      setAddressData(response.data.data);
      if (
        _.size(tempDataAdd) > 0 &&
        _.findIndex(addressData, {
          customerAddressBookId: _.get(_.findLast(tempDataAdd), 'customerAddressBookId'),
        }) === -1
      ) {

        const newData = [...addressData, _.findLast(tempDataAdd)];
        setAddressData(newData);
      }
      if (isEdit === true) {
        if (_.findIndex(addressData, { customerAddressBookId: _.get(info, 'destination.customer_address_book_id') }) === -1) {


          const newData = [
            {
              customerAddressBookId: _.get(info, 'destination.customer_address_book_id'),
              addressName: _.get(info, 'destination.address_name'),
              address: _.get(info, 'destination.address'),
              lat: _.get(info, 'destination.lat'),
              lng: _.get(info, 'destination.lng'),
            },
          ];

          setAddressData((prevArrays) => _.uniqBy([...prevArrays, ...newData], 'customerAddressBookId'));
          return _.uniqBy(newData);
        } else {

          return response.data.data;
        }
      }

      return response.data.data;
    } catch (error) { }
  };

  const getSize = async () => {
    try {
      const response = await instance.get(`v5/order/manager/company/${comCode}/web/ordersize/loopmerchant?sizeCode=s`);
      setSizeProduce(_.get(response, 'data.data.list[0]'));
    } catch (error) { }
  };

  const handleClickSave = () => {
    const comCode = GetProfile('customerCode');
    formCustomer
      .validateFields()
      .then(async (values) => {
        const filterContactCheck = {
          ...contactData,
          customerContactId: _.get(contactData, 'isTemp') === false ? undefined : _.get(contactData, 'customerContactId'),
          isTemp: undefined
        };

        const body = {
          customerDetail: customerDetail,
          statusDetail: isEdit ? undefined : 'open',
          trips: values.trips,
          destinationDetail: selectaddressData,
          sourceDetail: saveAddes,
          // deliveryDate: moment().format('YYYY-MM-DD'),
          // deliveryTime: moment().format('HH:mm'),
          contactDetail: filterContactCheck,
          orderNo: isEdit ? _.get(info, 'orderNo') : undefined,
          remark: values.remark,
          size: sizeProduce,
          weight: 0,
          referenceType: undefined,
          referenceNo: values.ref,
          parcel: values.parcel,
          customerShippingPrice: isEdit ? parseFloat(values.price) : values.price,
        };
        const id = _.get(info, 'orderId');
        const response = isEdit
          ? await instance.put(`/v5/order/manager/company/${comCode}/web/deliveryorder/loopmerchant/${id}`, body)
          : await instance.post(`/v5/order/manager/company/${comCode}/web/deliveryorder/loopmerchant`, body);

        successNotification(intl.formatMessage({ id: 'saveSuccessNotification', defaultMessage: 'Success' }));
        dispatch(triggerAction());
        formCustomer.resetFields();
        setIsDisable(true);
        if (isEdit === true) {
          // await getOrdersList(_.get(info, 'orderNo'));
          saveEditOrder();
        } else {
          await getOrdersList(_.get(response, 'data.data.orderNo'));
        }
        handleCancelThisModal()
      })
      .catch((info) => {
        errorNotification(intl.formatMessage({ id: 'saveErrorNotification', defaultMessage: 'Failed' }));
      });
  };

  const getOrdersList = async (payload) => {

    const search = {
      'contact.customerContactName': '',
      'contact.customerContactPhone': '',
      'customer.comtomerName': '',
      'destination.address': '',
      orderNo: payload,
      sizesizeName: '',
      sourceaddress: '',
      weightTxt: '',
    };

    const body = {
      search: search,
      'customer.customerId': customerId,
      limit: 1,
    };
    try {
      const response = await instance.post(`/v5/order/manager/company/${comCode}/web/deliveryorder/report/loopmerchant`, body);

      if (isEdit) {
        if (fromTracking === undefined) {
          // setFocusShipmentDetail(_.findLast(response.data.data.list))
          saveEditOrder(response.data.data.list);
        } else {
          saveEditOrder(response.data.data.list);
        }
      } else {
        onSave(_.findLast(response.data.data.list));
      }
    } catch (error) {
      return error.response.data;
    }
  };

  // const handleClickCancelEdit = () => {
  //   setIsEdit(false);
  // };

  const handleSelectName = (values, editvalue) => {

    if (_.size(editvalue) > 0) {
      if (_.size(editvalue) > 1) {
        setContactData(
          _.get(
            _.filter(customerData, (e) => {
              return e.customerContactId === values;
            }),
            '[0]'
          )
        );
      } else {
        setContactData(_.get(editvalue, '[0]'));
      }

      editvalue = [];
    } else {
      formCustomer.setFieldsValue({
        phone: _.get(
          _.filter(customerData, (e) => {
            return e.customerContactId === values;
          }),
          '[0].customerContactPhone'
        ),
        address: '',
      });
      setContactData(
        _.get(
          _.filter(customerData, (e) => {
            return e.customerContactId === values;
          }),
          '[0]'
        )
      );
    }

    getDataAddress(values);
    setIsDisable(false);
  };

  const handleClickViewAllCustomer = () => {
    setIsOpenSelectCustomer(true);
  };

  const handleClickViewAllAddr = () => {
    setIsOrder(true);
    setIsOpenSelectAddr(true);
  };

  const handleCloseSelectModal = () => {
    setIsOpenSelectCustomer(false);
    setIsOpenSelectAddr(false);
  };

  const handleSelectAddress = (values, addressEdit) => {
    const address = _.get(
      _.filter(isEdit ? addressEdit : addressData, (e) => {
        return e.customerAddressBookId === values;
      }),
      '[0]'
    );

    setSelectAddressData({
      customer_address_book_id: _.get(address, 'customerAddressBookId'),
      address_name: _.get(address, 'addressName'),
      address: _.get(address, 'address'),
      // address: _.get(address, 'fullAddress') ? _.get(address, 'address') + ',' + _.get(address, 'fullAddress') : _.get(address, 'address'),
      lat: _.get(address, 'lat'),
      lng: _.get(address, 'lng'),
    });
    // setSelectAddressData((e) => ({ ...e, address: _.get(address, 'address') + ',' + _.get(address, 'fullAddress') }));
  };

  const handleCancelThisModal = () => {
    onCancle();
    formCustomer.resetFields();
    setIsDisable(true);
    setCustomerData([]);
    setAddressData([]);
    setTempDataCus([]);
    setTempDataAdd([]);
  };

  return (
    <Modal
      className='create-shipment'
      style={{ marginTop: isDesktop ? '-50px' : null }}
      maskClosable={false}
      title={
        isEdit ? (
          <Typography color={COLORS.Primary} isBold size='16px' className={isDesktop ? 'pb-3' : 'text-center pb-2'}>
            <FormattedMessage id='modalEditOrder' defaultMessage='Edit Order' />
          </Typography>
        ) : (
          <Typography color={COLORS.Primary} isBold size='16px' className={isDesktop ? 'pb-3' : 'text-center pb-2'}>
            <FormattedMessage id='modalCreateOrder' defaultMessage='Create Order' />
          </Typography>
        )
      }
      open={isOpen}
      onOk={() => { }}
      onCancel={() => {
        onCancle();
        setIsDisable(true);
        formCustomer.resetFields();
      }}
      width={680}
      centered={isDesktop ? true : false}
      footer={[
        isDesktop ? (
          <>
            <MyButton
              onClick={() => {
                handleCancelThisModal()
                // onCancle();
                // formCustomer.resetFields();
                // setIsDisable(true);
                // setCustomerData([]);
                // setAddressData([]);
                // setTempDataCus([]);
                // setTempDataAdd([]);
              }}
              style={{
                width: isDesktop ? '25%' : '48%',
              }}
            >
              <FormattedMessage id='btnCancel' defaultMessage='Cancel' />
            </MyButton>
            <MyButton
              isPrimary
              onClick={handleClickSave}
              style={{
                width: isDesktop ? '25%' : '48%',
              }}
            >
              <FormattedMessage id='btnSave' defaultMessage='Save' />
            </MyButton>
          </>
        ) : (
          <div style={{ marginTop: '-12px' }}>
            <MyButton
              isPrimary
              onClick={handleClickSave}
              style={{
                width: isDesktop ? '25%' : '100%',
                marginBottom: '10px',
              }}
            >
              <FormattedMessage id='btnSave' defaultMessage='Save' />
            </MyButton>
            <MyButton
              onClick={() => {
                handleCancelThisModal()
              }}
              style={{
                width: isDesktop ? '25%' : '100%',
                marginLeft: '0px',
              }}
            >
              <FormattedMessage id='btnCancel' defaultMessage='Cancel' />
            </MyButton>
          </div>
        ),
      ]}
    >
      <Divider className='m-0' />
      <OrderForm
        isEdit={isEdit}
        onClickViewAllCustomer={handleClickViewAllCustomer}
        onClickViewAllAddr={handleClickViewAllAddr}
        customerData={customerData}
        form={formCustomer}
        getDataAddress={getDataAddress}
        addressData={addressData}
        isDisable={isDisable}
        setIsDisable={setIsDisable}
        setContactData={setContactData}
        handleSelectAddress={handleSelectAddress}
        handleSelectName={handleSelectName}
        contactData={contactData}
      // onChangeParcelNo={handleChangeParcelNo}
      />

      <SelectCustomerModal
        isOpen={isOpenSelectCustomer}
        onCancle={handleCloseSelectModal}
        customerData={customerData}
        setIsOpenSelectCustomer={setIsOpenSelectCustomer}
        setCustomerData={setCustomerData}
        setEvent={setEvent}
        formCustomer={formCustomer}
        handleSelectName={handleSelectName}
        tempDataCus={tempDataCus}
        setTempDataCus={setTempDataCus}
      />
      <SelectAddrModal
        isOpen={isOpenSelectAddr}
        onCancle={handleCloseSelectModal}
        addressData={addressData}
        setIsOpenSelectAddr={setIsOpenSelectAddr}
        setAddressData={setAddressData}
        setEvent={setEventAddress}
        formCustomer={formCustomer}
        isOrder={isOrder}
        setIsOrder={setIsOrder}
        contactData={contactData}
        tempDataAdd={tempDataAdd}
        setTempDataAdd={setTempDataAdd}
        handleSelectAddress={handleSelectAddress}
      />
    </Modal>
  );
};

export default OrderModal;
